import { Link } from "react-router-dom";
import ZeussToken from "../../../../Contract/zeussToken.json";
import BuyModalCrypto from "../../Layout/Modal/BuyModalCrypto";
const BuyCrypto = () => {
  const address = ZeussToken.address;
  const copyToClipboard = () => {
    navigator.clipboard
      .writeText(address)
      .then(() => alert("Address copied to clipboard!"))
      .catch((err) => console.error("Failed to copy:", err));
  };
  return (
    <>
      <section className="WhatPrcog BuyCrypto TribeAddress">
        <div className="container">
          <div className="row">
            <div className="col-12">
              {/* <ul className="list-inline">
                <li>
                  <img src="./images/buy1.png" alt="" />
                </li>
                <li>
                  <img src="./images/buy2.png" alt="" />
                </li>
                <li>
                  <img src="./images/buy3.png" alt="" />
                </li>
                <li>
                  <img src="./images/buy4.png" alt="" />
                </li>
                <li>
                  <img src="./images/buy5.png" alt="" />
                </li>
                <li>
                  <img src="./images/buy6.png" alt="" />
                </li>
              </ul> */}
              <div className="heading">
                {/* <h4>Buy Now with Credit Card or Crypto!</h4> */}
                <h4>Buy Now with Crypto!</h4>
                <div className="buttons">
                  {/* <Link
                    target="_blank"
                    to="https://www.paypal.com/ncp/payment/96YPBGW4W8UCU"
                  >
                    <button type="button" class="btn form-control">
                      <img
                        class="mx-2"
                        alt=""
                        src="./images/paypaliconyellow.png"
                        style={{ width: "15px" }}
                      />
                      Buy with PayPal
                    </button>
                  </Link> */}
                  <BuyModalCrypto />
                </div>
                <p>
                  ZForge World represents digital collectibles designed to
                  enhance engagement within the ZForge ecosystem. These
                  collectibles, including characters, items, and artwork, are
                  intended to support and celebrate the values embodied by
                  ZForge. They are not intended to be, or to be the subject of,
                  an investment opportunity, investment contract, or security of
                  any type. ZForge.world is a gaming and blockchain platform
                  focused on delivering immersive Play-to-Earn experiences. It
                  is not affiliated with any political campaigns, offices, or
                  governmental agencies. Terms & Conditions Apply.
                </p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-10 offset-lg-1">
              <div className="TribeAddressDiv" style={{ background: "#fff" }}>
                <div className="title">
                  <h4>$ZFORGE ERC20 Address</h4>
                </div>
                <div className="address">
                  <Link
                    target="_blank"
                    to={`https://etherscan.io/address/${ZeussToken.address}`}
                  >
                    {ZeussToken.address}
                  </Link>
                </div>
                <div className="btn-address">
                  <button onClick={copyToClipboard}>Copy address</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default BuyCrypto;
